import * as React from 'react'
import IncludeBreakfastSummary from './shared/IncludeBreakfastSummary'

import BabyCribSummary from './shared/BabyCribSummary'
import CO2Summary from './shared/CO2Summary'
import ExtraLuggageSummary from './shared/ExtraLuggageSummary'
import FlexibleRebookingSummary from './shared/FlexibleRebookingSummary'
import HandLuggageSummary from './shared/HandLuggageSumary'
import PrivateRoomSummary from './shared/PrivateRoomSummary'

const FlyExtrasSummary: React.FC = () => {
  return (
    <>
      <HandLuggageSummary />
      <ExtraLuggageSummary />
      <IncludeBreakfastSummary />
      <PrivateRoomSummary />
      <BabyCribSummary />
      <CO2Summary />
      <FlexibleRebookingSummary />
    </>
  )
}

export default FlyExtrasSummary
